// This file is modified during CI builds. Do not change this
// file unless you know what you are doing
const APPLICATION_VERSION = "v1.455.104-TSS-3105-mcastro-Add-button-hidden-in-Search-and-Add-Placements-dialog-when-results-load.1";

export const getApplicationVersion = (): string => APPLICATION_VERSION;
